// ชื่อมหาสมุทร ทะเล อ่าว และช่องแคบเป็นภาษาไทย (docs/PLAN.md ข้อ 4.2)
// คีย์คือชื่อในชั้น geography_marine_polys ของ Natural Earth ซึ่งมีแต่ชื่อภาษาอังกฤษ

/** น้ำในแผ่นดินที่ห่างทะเลมาก (เช่น ทะเลสาบใหญ่) ไม่มีชื่อใน Natural Earth */
export const LAKE_KEY = "(lake)";

export const SEA_NAME_TH: Readonly<Record<string, string>> = {
  [LAKE_KEY]: "ทะเลสาบ",
  "Adriatic Sea": "ทะเลเอเดรียติก",
  "Aegean Sea": "ทะเลอีเจียน",
  "Amazon River": "ปากแม่น้ำแอมะซอน",
  "Amundsen Gulf": "อ่าวอามุนด์เซน",
  "Amundsen Sea": "ทะเลอามุนด์เซน",
  "Andaman Sea": "ทะเลอันดามัน",
  "Arabian Sea": "ทะเลอาหรับ",
  "Arafura Sea": "ทะเลอาราฟูรา",
  "Arctic Ocean": "มหาสมุทรอาร์กติก",
  "Baffin Bay": "อ่าวแบฟฟิน",
  "Bahía de Campeche": "อ่าวกัมเปเช",
  "Balearic Sea": "ทะเลแบลีแอริก",
  "Baltic Sea": "ทะเลบอลติก",
  "Banda Sea": "ทะเลบันดา",
  "Barents Sea": "ทะเลแบเรนตส์",
  "Bay of Bengal": "อ่าวเบงกอล",
  "Bay of Biscay": "อ่าวบิสเคย์",
  "Bay of Fundy": "อ่าวฟันดี",
  "Bay of Plenty": "อ่าวเพลนตี",
  "Beaufort Sea": "ทะเลโบฟอร์ต",
  "Bellingshausen Sea": "ทะเลเบลลิงส์เฮาเซน",
  "Bering Sea": "ทะเลแบริ่ง",
  "Bismarck Sea": "ทะเลบิสมาร์ก",
  "Black Sea": "ทะเลดำ",
  "Bo Hai": "อ่าวปั๋วไห่",
  "Bristol Bay": "อ่าวบริสตอล",
  "Bristol Channel": "ช่องแคบบริสตอล",
  "Caribbean Sea": "ทะเลแคริบเบียน",
  "Caspian Sea": "ทะเลแคสเปียน",
  "Celebes Sea": "ทะเลเซเลบีส",
  "Ceram Sea": "ทะเลเซรัม",
  "Chesapeake Bay": "อ่าวเชซาพีก",
  "Chukchi Sea": "ทะเลชุกชี",
  "Columbia River": "ปากแม่น้ำโคลัมเบีย",
  "Cook Inlet": "อ่าวคุก",
  "Coral Sea": "ทะเลคอรัล",
  "Davis Strait": "ช่องแคบเดวิส",
  "Drake Passage": "ช่องแคบเดรก",
  "East China Sea": "ทะเลจีนตะวันออก",
  "English Channel": "ช่องแคบอังกฤษ",
  "Golfe du Lion": "อ่าวลียง",
  "Golfo San Jorge": "อ่าวซานฆอร์เฆ",
  "Golfo de California": "อ่าวแคลิฟอร์เนีย",
  "Golfo de Panamá": "อ่าวปานามา",
  "Great Australian Bight": "อ่าวเกรตออสเตรเลียนไบต์",
  "Great Barrier Reef": "แนวปะการังเกรตแบร์ริเออร์รีฟ",
  "Greenland Sea": "ทะเลกรีนแลนด์",
  "Gulf of Aden": "อ่าวเอเดน",
  "Gulf of Alaska": "อ่าวอะแลสกา",
  "Gulf of Bothnia": "อ่าวบอทเนีย",
  "Gulf of Carpentaria": "อ่าวคาร์เพนแทเรีย",
  "Gulf of Finland": "อ่าวฟินแลนด์",
  "Gulf of Guinea": "อ่าวกินี",
  "Gulf of Honduras": "อ่าวฮอนดูรัส",
  "Gulf of Kutch": "อ่าวกัจฉ์",
  "Gulf of Maine": "อ่าวเมน",
  "Gulf of Mannar": "อ่าวมันนาร์",
  "Gulf of Mexico": "อ่าวเม็กซิโก",
  "Gulf of Oman": "อ่าวโอมาน",
  "Gulf of Saint Lawrence": "อ่าวเซนต์ลอว์เรนซ์",
  "Gulf of Thailand": "อ่าวไทย",
  "Gulf of Tonkin": "อ่าวตังเกี๋ย",
  "Hudson Bay": "อ่าวฮัดสัน",
  "Hudson Strait": "ช่องแคบฮัดสัน",
  "INDIAN OCEAN": "มหาสมุทรอินเดีย",
  "Inner Sea": "ทะเลเซโตะใน",
  "Inner Seas": "ทะเลในของสกอตแลนด์",
  "Ionian Sea": "ทะเลไอโอเนียน",
  "Irish Sea": "ทะเลไอริช",
  "James Bay": "อ่าวเจมส์",
  "Java Sea": "ทะเลชวา",
  "Kara Sea": "ทะเลคารา",
  "Korea Strait": "ช่องแคบเกาหลี",
  "Labrador Sea": "ทะเลแลบราดอร์",
  "Laccadive Sea": "ทะเลลักษทวีป",
  "Laptev Sea": "ทะเลลัปเตฟ",
  "Luzon Strait": "ช่องแคบลูซอน",
  "Makassar Strait": "ช่องแคบมากัสซาร์",
  "Mediterranean Sea": "ทะเลเมดิเตอร์เรเนียน",
  "Melville Bay": "อ่าวเมลวิลล์",
  "Molucca Sea": "ทะเลโมลุกกะ",
  "Mozambique Channel": "ช่องแคบโมซัมบิก",
  "North Atlantic Ocean": "มหาสมุทรแอตแลนติกเหนือ",
  "North Pacific Ocean": "มหาสมุทรแปซิฟิกเหนือ",
  "North Sea": "ทะเลเหนือ",
  "Norwegian Sea": "ทะเลนอร์เวย์",
  "Persian Gulf": "อ่าวเปอร์เซีย",
  "Philippine Sea": "ทะเลฟิลิปปิน",
  "Red Sea": "ทะเลแดง",
  "Ross Sea": "ทะเลรอสส์",
  "Río de la Plata": "ปากแม่น้ำรีโอเดลาปลาตา",
  "SOUTHERN OCEAN": "มหาสมุทรใต้",
  "Sargasso Sea": "ทะเลซาร์กัสโซ",
  "Scotia Sea": "ทะเลสโกเชีย",
  "Sea of Japan": "ทะเลญี่ปุ่น",
  "Sea of Okhotsk": "ทะเลโอค็อตสค์",
  "Shelikhova Gulf": "อ่าวเชลีโฮฟ",
  "Solomon Sea": "ทะเลโซโลมอน",
  "South Atlantic Ocean": "มหาสมุทรแอตแลนติกใต้",
  "South China Sea": "ทะเลจีนใต้",
  "South Pacific Ocean": "มหาสมุทรแปซิฟิกใต้",
  "Strait of Gibraltar": "ช่องแคบยิบรอลตาร์",
  "Strait of Malacca": "ช่องแคบมะละกา",
  "Strait of Singapore": "ช่องแคบสิงคโปร์",
  "Straits of Florida": "ช่องแคบฟลอริดา",
  "Sulu Sea": "ทะเลซูลู",
  "Taiwan Strait": "ช่องแคบไต้หวัน",
  "Tasman Sea": "ทะเลแทสมัน",
  "The North Western Passages": "ช่องทางตะวันตกเฉียงเหนือ",
  "Timor Sea": "ทะเลติมอร์",
  "Tyrrhenian Sea": "ทะเลทิร์เรเนียน",
  "Ungava Bay": "อ่าวอันกาวา",
  "Viscount Melville Sound": "ช่องแคบไวเคานต์เมลวิลล์",
  "Weddell Sea": "ทะเลเวดเดลล์",
  "White Sea": "ทะเลขาว",
  "Yangtze River": "ปากแม่น้ำแยงซี",
  "Yellow Sea": "ทะเลเหลือง",
};
